export interface DeductionStatusProps {
  statusId: number;
  statusKey: string;
  statusName: string;
  isCurrent: boolean;
}

export class DeductionStatus {
  private readonly _statusId: number;
  private readonly _statusKey: string;
  private readonly _statusName: string;
  private readonly _isCurrent: boolean;

  constructor(props: DeductionStatusProps) {
    this._statusId = props.statusId;
    this._statusKey = props.statusKey;
    this._statusName = props.statusName;
    this._isCurrent = props.isCurrent;
  }

  public get statusId(): number {
    return this._statusId;
  }

  public get statusKey(): string {
    return this._statusKey;
  }

  public get statusName(): string {
    return this._statusName;
  }

  public get isCurrent(): boolean {
    return this._isCurrent;
  }
}
